var RecruitHeroEvent = {}
// 竖版事件
// 用于处理红点
RecruitHeroEvent.RecruitHeroBaseInfo = "RecruitHeroEvent.RecruitHeroBaseInfo"

module.exports = RecruitHeroEvent;